import React from "react";

export default function MarketsNavIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 27 28"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink">
      <g
        id="Symbols"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round">
        <g
          id="Sidemenu-/-Item-Unselected"
          transform="translate(-19.000000, -6.000000)"
          stroke="#FFFFFF"
          strokeWidth="1.5">
          <g id="Icons-/-Line-/-Dashboard" transform="translate(20.000000, 7.435484)">
            <line x1="0.05" y1="0" x2="0.05" y2="24.9500998" id="Path"></line>
            <line x1="25" y1="24.9501996" x2="0.0499001996" y2="24.9501996" id="Path"></line>
            <polyline
              id="Path"
              points="3.28443114 17.8013972 10.3862275 10.737525 14.4720559 14.6706587 21.7654691 7.14870259"></polyline>
            <polyline
              id="Path"
              points="21.7654691 10.6347305 21.7654691 7.14870259 18.2784431 7.14870259"></polyline>
          </g>
        </g>
      </g>
    </svg>
  );
}
